module.exports = __webpack_public_path__ + "static/media/insurance-benefits.59c9de34.mp3";